module.exports = __webpack_public_path__ + "static/media/jsg.2c1a7ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/jsg.jpg
// module id = 693
// module chunks = 0